// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminNavigationController from "./admin_navigation_controller"
application.register("admin-navigation", AdminNavigationController)

import BookFormController from "./book_form_controller"
application.register("book-form", BookFormController)

import BookCoverController from "./book_cover_controller"
application.register("book-cover", BookCoverController)

import GenrePickerController from "./genre_picker_controller"
application.register("genre-picker", GenrePickerController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BannerImageController from "./banner_image_controller"
application.register("banner-image", BannerImageController)

import BookPurchaseController from "./book_purchase_controller"
application.register("book-purchase", BookPurchaseController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import CharCounterController from "./char_counter_controller"
application.register("char-counter", CharCounterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import EventsCarouselController from "./events_carousel_controller"
application.register("events-carousel", EventsCarouselController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MoneyController from "./money_controller"
application.register("money", MoneyController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)

import SaleCartController from "./sale_cart_controller"
application.register("sale-cart", SaleCartController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SegmentedController from "./segmented_controller"
application.register("segmented", SegmentedController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ShareLinkController from "./share_link_controller"
application.register("share-link", ShareLinkController)
